"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBundleDataFromLocalStorage = exports.persistBundleDataInLocalStorage = void 0;
const pattern_library_utils_storage_1 = require("@saatva-bits/pattern-library.utils.storage");
const BUNDLE_LOCAL_STORAGE_KEY = 'bundleProducts';
const persistBundleDataInLocalStorage = (bundleVariant) => {
    try {
        const storage = (0, pattern_library_utils_storage_1.storageWrapper)();
        const currentProductBundle = storage.getItem(BUNDLE_LOCAL_STORAGE_KEY, 'local');
        // only save the data we need to serialize the variant for data layer pushes
        const { bundledVariants, productCode, sku, category, subcategory, attributes, } = bundleVariant;
        const bundleProductToAdd = {
            bundledVariants,
            productCode,
            sku,
            category,
            subcategory,
            attributes
        };
        let bundleProducts = [bundleProductToAdd];
        // if we have bundles stored and the current bundle does not exist, add it to the array
        if (currentProductBundle && !currentProductBundle.some(bundle => bundle.sku === bundleVariant.sku)) {
            bundleProducts = [...bundleProducts, ...currentProductBundle];
        }
        storage.setItem(BUNDLE_LOCAL_STORAGE_KEY, bundleProducts, 'local');
    }
    catch (error) {
        console.error('[persistBundleDataInLocalStorage] Error adding bundle to local storage', error); // eslint-disable-line
    }
};
exports.persistBundleDataInLocalStorage = persistBundleDataInLocalStorage;
const getBundleDataFromLocalStorage = () => {
    const storage = (0, pattern_library_utils_storage_1.storageWrapper)();
    return storage.getItem(BUNDLE_LOCAL_STORAGE_KEY, 'local');
};
exports.getBundleDataFromLocalStorage = getBundleDataFromLocalStorage;
//# sourceMappingURL=bundles.js.map